import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { InvitationState, UserRole } from '../../types/Users';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/team/members', 'get'>;

type TeamMember = {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string;
  role: UserRole;
  inviteState: InvitationState;
};

type Result = TeamMember[];

export const listTeamMembersFactory = (apiClient: ApiClient) => {
  const listTeamMembers = async () => {
    const response = await apiClient['/api/team/members'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return response.map((member) => ({
      id: member.id,
      firstName: member.firstName ?? null,
      lastName: member.lastName ?? null,
      email: member.email,
      role: member.role,
      inviteState: member.inviteState,
    }));
  };

  return listTeamMembers;
};
